import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentQueue } from "../../../../../@types/attendance-local-department-queue";
import { AttendanceLocal } from "../../../../../@types/attendance-local";

export type AttendanceLocalDepartmentQueueUpdateData = Pick<
    AttendanceLocalDepartmentQueue,
    | "setor"
    | "data_inicio"
    | "data_fim"
    | "ignorar_feriados"
    | "sabado"
    | "domingo"
> & {
    unidade: AttendanceLocal["slug_unidade"];
};

export function useAttendanceLocalDepartmentQueueUpdate(id: AttendanceLocalDepartmentQueue["id"]) {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        AttendanceLocalDepartmentQueue,
        AxiosError<{ detail: string; data_inicio: string; data_fim: string; }>,
        AttendanceLocalDepartmentQueueUpdateData
    >({
        mutationKey: ["attendance-local", "department", "queue", "update", id],
        mutationFn: async (data: AttendanceLocalDepartmentQueueUpdateData) => {
            const response = await apisiseci.put<AttendanceLocalDepartmentQueue>(
                `/cms/fila_horarios/${id}/`, data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Fila atualizado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "department", "queue", "list"],
            });
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail
                || error?.response?.data?.data_inicio
                || error?.response?.data?.data_fim
                || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
